import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Form, Input, Select, Space, Spin, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { adminAPI, schoolAPI } from '../../services/api';

const AdminEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [adminRes, schoolRes] = await Promise.all([
          adminAPI.getById(id),
          schoolAPI.getAll()
        ]);
        const adminData = adminRes.data.data || {};
        setSchools(schoolRes.data.data || []);
        form.setFieldsValue({
          username: adminData.username,
          name: adminData.name || adminData.displayName || adminData.display_name,
          phone: adminData.phone,
          email: adminData.email,
          schoolId: adminData.schoolId ? String(adminData.schoolId) : adminData.school_id ? String(adminData.school_id) : undefined,
          status: adminData.status
        });
      } catch (err) {
        setError(err.response?.data?.message || '获取学校管理员信息失败');
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [form, id]);

  const onFinish = async (values) => {
    setSubmitting(true);
    try {
      const { schoolId, ...profile } = values;
      await adminAPI.update(id, profile);
      message.success('学校管理员信息已保存');
      navigate('/admins');
    } catch (err) {
      message.error(err.response?.data?.message || '保存学校管理员失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card title="编辑学校管理员">
      <Spin spinning={loading}>
        {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item name="schoolId" label="所属学校" extra="学校授权与交接请从该标准学校的管理员设置中操作。" rules={[{ required: true, message: '请选择所属学校' }]}>
            <Select
              disabled
              showSearch
              placeholder="请选择所属学校"
              optionFilterProp="label"
              options={schools.map((school) => ({ label: school.name, value: String(school.id) }))}
            />
          </Form.Item>

          <Form.Item name="username" label="登录用户名" rules={[{ required: true, message: '请输入登录用户名' }, { min: 3, message: '用户名至少 3 位' }]}>
            <Input placeholder="用于登录管理后台" />
          </Form.Item>

          <Form.Item name="name" label="姓名" rules={[{ required: true, message: '请输入姓名' }]}>
            <Input placeholder="请输入学校管理员姓名" />
          </Form.Item>

          <Form.Item name="phone" label="手机号">
            <Input placeholder="请输入手机号" />
          </Form.Item>

          <Form.Item name="email" label="邮箱" rules={[{ type: 'email', message: '请输入有效邮箱' }]}>
            <Input placeholder="请输入邮箱" />
          </Form.Item>

          <Form.Item name="password" label="重置登录密码" extra="不填写则保持原密码不变" rules={[{ min: 6, message: '密码至少 6 位' }]}>
            <Input.Password placeholder="需要重置时填写新密码" />
          </Form.Item>

          <Form.Item name="status" label="账号状态" rules={[{ required: true, message: '请选择账号状态' }]}>
            <Select
              options={[
                { label: '正常', value: 'active' },
                { label: '停用', value: 'disabled' }
              ]}
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={submitting}>保存</Button>
              <Button onClick={() => navigate('/admins')}>取消</Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
};

export default AdminEdit;
